export const css = {
    root: '_3fcRGQVI',
    card: '_1AhtzYgk',
    title: '_3lM0vv3Y',
    activity_intro: '_33PzWVgL',
    teach_me: '_1odUjZV5',
    teach_me_tooltip: '_1FVfeIuj',
    quiz_me: 'Arvg0P1V',
    quiz_me_tooltip: '_2paxpvzd',
    icon: '_3J5z9FFc',
    close: 'HD8umcNT',
    skel: 'MQBvdpyj',
    skelWithTooltip: '_3FBLR-XX',
    enter: '_1VsyQv4W',
    'slide-in': '_fi0bWcW',
    exit: '_2WIJcUMm',
    'slide-out': '_11iuAutH',
    expanded_content: '_2pCzFitd',
    twoColumn: '_3kgKmdph',
    shortDesc: '_16qFuhfr',
    topicgroups: 'vRnmgX49',
    item: '_1zT5SI0h',
    topicquiz: '_2ltmEQTR',
    ' _key': 'afcpe-theme/afcpe/card/expanded'
};
export default css;
